import { definePropType } from "@types-vue/props";
import { defineComponent, computed } from "vue";
export default defineComponent({
    props: {
        config: {
            type: definePropType(Object),
            required: true
        }
    },
    setup: function setup(props) {
        var handleClick = function handleClick() {
            props.config.onClick && props.config.onClick();
        };
        // 定义icon位置
        var isIconLeft = computed(function() {
            return props.config.iconConfig && props.config.iconConfig.position === "before";
        });
        // iconClass
        var innerIconClass = computed(function() {
            var ref;
            return props.config.iconClass || ((ref = props.config.iconConfig) === null || ref === void 0 ? void 0 : ref.class) || "arrow_right";
        });
        return {
            handleClick: handleClick,
            innerIconClass: innerIconClass,
            isIconLeft: isIconLeft
        };
    }
});
